import React from 'react'
import './_styles.scss'

/**
 * ScrollIndicator — scrollbar customizable reutilizable.
 *
 * Props:
 *  onKeyDown      {func}   — handler de teclado (UP/DOWN)
 *  scrollRatio    {number} — posición del thumb: 0 = top, 1 = bottom
 *  className      {string} — clase de posicionamiento y contexto (ej: 'ranking-scrollbar')
 *  trackHeightRem {number} — alto del track en rem
 *  thumbHeightRem {number} — alto del thumb en rem
 */
function ScrollIndicator ({
  onKeyDown,
  scrollRatio,
  className,
  trackHeightRem,
  thumbHeightRem
}) {
  var sRatio = scrollRatio != null ? scrollRatio : 0
  var trackH = trackHeightRem != null ? trackHeightRem : 34.67
  var thumbH = thumbHeightRem != null ? thumbHeightRem : 11.4
  var THUMB_H_PCT = thumbH / trackH * 100
  var thumbTop = sRatio * (100 - THUMB_H_PCT)

  return (
    <div
      className={'scroll-indicator focusable' + (className ? ' ' + className : '')}
      tabIndex={0}
      onKeyDown={onKeyDown}
      style={{ height: trackH + 'rem' }}
    >
      <div className='scroll-indicator__track' />
      <div
        className='scroll-indicator__thumb'
        style={{ top: thumbTop + '%', height: thumbH + 'rem' }}
      />
    </div>
  )
}

export default ScrollIndicator



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/Components/ScrollIndicator/index.jsx